import {
  IsoCountryCode2,
  asIsoCountryCode2,
  getDefaultLanguage,
  getLanguages,
} from '@rbilabs/intl';

import { loadLanguage } from 'state/intl/load-language';
import { loadRegion } from 'state/intl/load-region';
import { brand, country } from 'utils/environment';

import { REGIONAL_APP } from './regional-app';

export const loadLocale = () => {
  if (REGIONAL_APP) {
    const region = country?.toUpperCase();

    const regionSupportedLanguages = getLanguages(brand(), region);
    const hasMultipleLanguages = region && regionSupportedLanguages.length > 1;
    // If region has multiple languages, access language from selection history (or default if not available)
    // otherwise lock in default language
    const language = hasMultipleLanguages ? loadLanguage() : getDefaultLanguage(brand(), region);
    const supportedRegion = asIsoCountryCode2(region) || IsoCountryCode2.AQ;

    return { language, region: supportedRegion };
  }
  return { language: loadLanguage(), region: loadRegion() };
};
